import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// CRM / Sales (HubSpot deals, ConnectWise opportunities). Owned by the crm module (D8).
export const routes: RouteObject[] = [
  { path: 'crm', lazy: page(() => import('./board-page'), (m) => m.BoardPage) },
  { path: 'crm/deals', lazy: page(() => import('./deals-page'), (m) => m.DealsPage) },
  { path: 'crm/deals/:dealId', lazy: page(() => import('./deal-detail'), (m) => m.DealDetailPage) },
  { path: 'crm/tasks', lazy: page(() => import('./tasks-page'), (m) => m.TasksPage) },
  { path: 'crm/settings', lazy: page(() => import('./settings-page'), (m) => m.SettingsPage) },
];

export const orgRoutes: RouteObject[] = [{ path: 'deals', lazy: page(() => import('./org-deals'), (m) => m.OrgDealsPage) }];
